module.exports = __webpack_public_path__ + "img/AT0000002414074.dbe3b4d8.png";